import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import PartnerPortalNav from './components/PartnerPortalNav';
import { PartnerAuthProvider, usePartnerAuth } from './context/PartnerAuthContext';
import { PartnerBusinessProvider } from './context/PartnerBusinessContext';

const PartnerPortalShell: React.FC = () => (
  <div className="min-h-screen bg-[#fcf7fa] font-jakarta text-[#2a0f2a] antialiased">
    <PartnerPortalNav />
    <main className="mx-auto w-full max-w-[1200px] px-5 py-8 sm:px-8 sm:py-10">
      <Outlet />
    </main>
  </div>
);

const PartnerAuthGuard: React.FC = () => {
  const { user, isLoading } = usePartnerAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center font-jakarta text-[#5a3158]">
        Cargando…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/partners/registro" replace />;
  }

  return <Outlet />;
};

export const PartnerPortalProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <PartnerAuthProvider>
    <PartnerBusinessProvider>{children}</PartnerBusinessProvider>
  </PartnerAuthProvider>
);

export { PartnerPortalShell, PartnerAuthGuard };
